import { render, staticRenderFns } from "./PayrollChangeRequestDetail.vue?vue&type=template&id=778373aa&"
import script from "./PayrollChangeRequestDetail.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollChangeRequestDetail.vue?vue&type=style&index=0&id=778373aa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports